import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "Container",
  componentId: "iijq50-0"
})(["position:absolute;top:", "px;left:", "px;width:", "px;height:", "px;pointer-events:none;"], function (props) {
  return props.overlayPosition.top;
}, function (props) {
  return props.overlayPosition.left;
}, function (props) {
  return props.overlayPosition.width;
}, function (props) {
  return props.overlayPosition.height;
});